module.exports = __webpack_public_path__ + "be920b92a0140d705a00b72773d8a04a.pdf";